import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Wall Clocks",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Add a touch of timeless charm to your walls with our elegant Wall Clocks. Perfect for kitchens, bedrooms, or living areas, they combine functionality with artistic flair. Add a touch of timeless charm to your walls with our elegant Wall Clocks. Perfect for kitchens, bedrooms, or living areas, they combine functionality with artistic flair.",
        description: "Our Wall Clocks feature high-precision quartz movement for accurate timekeeping, housed in durable materials like metal, wood, or acrylic. With a variety of designs—from vintage to minimalist—these clocks enhance any space's décor while staying silent and reliable. Easy to hang and powered by batteries, they are both practical and decorative. Our Wall Clocks feature high-precision quartz movement for accurate timekeeping, housed in durable materials like metal, wood, or acrylic. With a variety of designs—from vintage to minimalist—these clocks enhance any space's décor while staying silent and reliable. Easy to hang and powered by batteries, they are both practical and decorative.",
        category: ["Wall Decor", "Home Accessories"],
        tags: ["clock", "wall", "decor"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Wood, Metal & Acrylic" },
            { id: 2, title: "Clock Type", content: "Quartz Movement" },
            { id: 3, title: "Color Options", content: "Black, White, Gold" },
            { id: 4, title: "Battery", content: "Requires 1 AA Battery (not included)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Mia Reynolds",
                date: "Feb 12, 2025",
                rating: 5,
                content: "Stylish and silent! Looks perfect on my accent wall. Highly recommended."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Liam Carter",
                date: "Feb 20, 2025",
                rating: 4.5,
                content: "Beautiful design and accurate time. It adds charm to the room effortlessly."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Dining Table",
        price: 50,
        disprice: 40,
        stock: 6,
        content: "Gather family and friends around our beautifully crafted Dining Table. Built for durability and elegance, it brings warmth and sophistication to any dining area. Gather family and friends around our beautifully crafted Dining Table. Built for durability and elegance, it brings warmth and sophistication to any dining area.",
        description: "Our Dining Table features a sturdy hardwood frame with a smooth, polished surface—perfect for everyday meals or special occasions. The design blends traditional charm with modern flair, fitting seamlessly into both casual and formal dining settings. With easy-to-maintain finishes and spacious seating, this table becomes the heart of your home. Our Dining Table features a sturdy hardwood frame with a smooth, polished surface—perfect for everyday meals or special occasions. The design blends traditional charm with modern flair, fitting seamlessly into both casual and formal dining settings. With easy-to-maintain finishes and spacious seating, this table becomes the heart of your home.",
        category: ["Furniture Pieces", "Home Accessories"],
        tags: ["table", "dining", "furniture"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Wood & Veneer" },
            { id: 2, title: "Seating Capacity", content: "4-6 People" },
            { id: 3, title: "Color Options", content: "Walnut, Espresso, Natural" },
            { id: 4, title: "Assembly", content: "Simple assembly required with tools included" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Emma Walker",
                date: "Mar 02, 2025",
                rating: 5,
                content: "Excellent quality! The table looks even better in person. Very sturdy and elegant."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Noah Bennett",
                date: "Mar 08, 2025",
                rating: 4.5,
                content: "Easy to assemble and fits perfectly in our dining space. Great value for the price!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Framed Wall Art",
        price: 50,
        disprice: 40,
        stock: 4,
        content: "Elevate your space with our elegant Framed Wall Art—designed to bring beauty, inspiration, and personality to your walls. Ideal for living rooms, bedrooms, or hallways. Elevate your space with our elegant Framed Wall Art—designed to bring beauty, inspiration, and personality to your walls. Ideal for living rooms, bedrooms, or hallways.",
        description: "Our Framed Wall Art collection features high-resolution prints on premium paper, secured in durable wooden or metal frames. From abstract designs to scenic landscapes, each piece adds visual depth and character to your decor. Easy to hang and built to last, these art pieces are perfect for creating a gallery-style wall or making a single bold statement. Our Framed Wall Art collection features high-resolution prints on premium paper, secured in durable wooden or metal frames. From abstract designs to scenic landscapes, each piece adds visual depth and character to your decor. Easy to hang and built to last, these art pieces are perfect for creating a gallery-style wall or making a single bold statement.",
        category: ["Wall Decor", "Home Accessories"],
        tags: ["art", "frame", "decor"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Printed Paper & Wood/Metal Frame" },
            { id: 2, title: "Dimensions", content: "24 x 36 inches (varies by design)" },
            { id: 3, title: "Style Options", content: "Abstract, Modern, Nature" },
            { id: 4, title: "Mounting", content: "Ready to hang with hooks included" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Sophia Harper",
                date: "Mar 15, 2025",
                rating: 5,
                content: "Absolutely love the quality and design. It transformed my wall instantly!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Elijah Brooks",
                date: "Mar 21, 2025",
                rating: 4.5,
                content: "Great value and beautiful prints. I ordered two and they look stunning together."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Decorative Vase",
        price: 50,
        disprice: 40,
        stock: 0,
        content: "Enhance your interior with our beautifully crafted Decorative Vase. Ideal for fresh flowers or as a standalone accent piece in any room. Enhance your interior with our beautifully crafted Decorative Vase. Ideal for fresh flowers or as a standalone accent piece in any room.",
        description: "Our Decorative Vase is made from high-quality ceramic, glass, or metal, offering both modern and classic styles. Whether placed on a table, shelf, or mantel, it adds a refined touch to your space. With elegant finishes and artistic shapes, it's the perfect home accent for both everyday décor and special arrangements. Our Decorative Vase is made from high-quality ceramic, glass, or metal, offering both modern and classic styles. Whether placed on a table, shelf, or mantel, it adds a refined touch to your space. With elegant finishes and artistic shapes, it's the perfect home accent for both everyday décor and special arrangements.",
        category: ["Home Accessories", "Wall Decor"],
        tags: ["vase", "decor", "ceramic"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Ceramic / Glass / Metal" },
            { id: 2, title: "Height", content: "10 - 14 inches (varies by design)" },
            { id: 3, title: "Color Options", content: "White, Gold, Blue" },
            { id: 4, title: "Care Instructions", content: "Wipe clean with a soft cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Chloe Turner",
                date: "Apr 03, 2025",
                rating: 5,
                content: "Looks elegant on my console table. Love the shape and finish!"
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Henry Collins",
                date: "Apr 09, 2025",
                rating: 4.5,
                content: "Stylish and well-made. I use it for both fresh and faux flowers."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Table Lamp",
        price: 50,
        disprice: 40,
        stock: 9,
        content: "Brighten your home with our stylish Table Lamp, perfect for desks, nightstands, or cozy corners. A blend of form and function for any modern space. Brighten your home with our stylish Table Lamp, perfect for desks, nightstands, or cozy corners. A blend of form and function for any modern space.",
        description: "Our Table Lamp features a sleek base with a high-quality fabric or glass shade, offering soft and ambient lighting for your space. Ideal for bedrooms, offices, or reading nooks, the lamp adds warmth and character while complementing a range of interior styles. The sturdy build, energy-efficient bulb compatibility, and user-friendly switch make it a practical yet decorative lighting solution. Our Table Lamp features a sleek base with a high-quality fabric or glass shade, offering soft and ambient lighting for your space. Ideal for bedrooms, offices, or reading nooks, the lamp adds warmth and character while complementing a range of interior styles. The sturdy build, energy-efficient bulb compatibility, and user-friendly switch make it a practical yet decorative lighting solution.",
        category: ["Lighting Fixtures", "Home Accessories"],
        tags: ["lamp", "lighting", "decor"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Metal Base & Fabric/Glass Shade" },
            { id: 2, title: "Height", content: "16 - 22 inches" },
            { id: 3, title: "Color Options", content: "Black, White, Brass" },
            { id: 4, title: "Bulb Type", content: "E26 LED Compatible (Bulb not included)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Mia Edwards",
                date: "Apr 15, 2025",
                rating: 5,
                content: "Gives off a lovely warm light. Looks great on my nightstand!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Liam Foster",
                date: "Apr 19, 2025",
                rating: 4.5,
                content: "Solid build, easy to assemble. Perfect balance of style and function."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Window Blinds",
        price: 50,
        disprice: 40,
        stock: 5,
        content: "Control light and privacy in style with our versatile Window Blinds. Designed for modern homes, they enhance both function and aesthetics. Control light and privacy in style with our versatile Window Blinds. Designed for modern homes, they enhance both function and aesthetics.",
        description: "Our Window Blinds offer a sleek and practical solution for managing natural light in any room. Made from durable materials like faux wood, PVC, or fabric, they are easy to operate and maintain. Whether you prefer vertical, horizontal, or roller styles, each set is crafted to blend seamlessly with your décor while providing optimal light control and privacy. Our Window Blinds offer a sleek and practical solution for managing natural light in any room. Made from durable materials like faux wood, PVC, or fabric, they are easy to operate and maintain. Whether you prefer vertical, horizontal, or roller styles, each set is crafted to blend seamlessly with your décor while providing optimal light control and privacy.",
        category: ["Window Treatments", "Home Accessories"],
        tags: ["blinds", "windows", "privacy"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Faux Wood / PVC / Fabric" },
            { id: 2, title: "Mount Type", content: "Inside & Outside Mount" },
            { id: 3, title: "Control Type", content: "Corded / Cordless Options" },
            { id: 4, title: "Cleaning", content: "Dust regularly or wipe with a damp cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Noah Peterson",
                date: "May 01, 2025",
                rating: 5,
                content: "Easy to install and works perfectly! Clean look and smooth operation."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Emily Carter",
                date: "May 05, 2025",
                rating: 4.5,
                content: "Stylish and functional. These blinds really upgraded our bedroom!"
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Wall Mirror",
        price: 50,
        disprice: 40,
        stock: 3,
        content: "Add depth and brightness to your space with our elegant Wall Mirror. A timeless piece that enhances any room's style and ambiance. Add depth and brightness to your space with our elegant Wall Mirror. A timeless piece that enhances any room's style and ambiance.",
        description: "Our Wall Mirror features a sturdy frame and high-reflective glass, perfect for both decorative and practical use. Available in a variety of shapes and finishes, it complements bedrooms, entryways, bathrooms, and living areas. Whether you're adding light or creating a focal point, this mirror brings sophistication and function to your interiors. Our Wall Mirror features a sturdy frame and high-reflective glass, perfect for both decorative and practical use. Available in a variety of shapes and finishes, it complements bedrooms, entryways, bathrooms, and living areas. Whether you're adding light or creating a focal point, this mirror brings sophistication and function to your interiors.",
        category: ["Wall Decor", "Home Accessories"],
        tags: ["mirror", "decor", "glass"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Tempered Glass & Wood/Metal Frame" },
            { id: 2, title: "Shape Options", content: "Round, Rectangular, Oval" },
            { id: 3, title: "Mounting Type", content: "Wall-Mounted with Included Hardware" },
            { id: 4, title: "Care Instructions", content: "Wipe with glass cleaner and soft cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Ella Morgan",
                date: "May 10, 2025",
                rating: 5,
                content: "Looks stunning above my console table. Great quality and easy to hang!"
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "James Bennett",
                date: "May 13, 2025",
                rating: 4.5,
                content: "Perfect size and beautiful finish. It brightens up my living room."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Solar Panels",
        price: 50,
        disprice: 40,
        stock: 0,
        content: "Harness clean energy with our high-efficiency Solar Panels. Ideal for residential or small business use, they offer savings and sustainability. Harness clean energy with our high-efficiency Solar Panels. Ideal for residential or small business use, they offer savings and sustainability.",
        description: "Our Solar Panels are built with premium-grade photovoltaic cells for optimal energy output, even in low-light conditions. With a robust frame and weather-resistant surface, these panels are designed to withstand outdoor environments and deliver long-term performance. Easy to install and compatible with various systems, they help reduce your carbon footprint and electricity costs. Our Solar Panels are built with premium-grade photovoltaic cells for optimal energy output, even in low-light conditions. With a robust frame and weather-resistant surface, these panels are designed to withstand outdoor environments and deliver long-term performance. Easy to install and compatible with various systems, they help reduce your carbon footprint and electricity costs.",
        category: ["Home Accessories", "Window Treatments"],
        tags: ["solar", "energy", "eco-friendly"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Monocrystalline Silicon" },
            { id: 2, title: "Power Output", content: "100W - 400W" },
            { id: 3, title: "Durability", content: "Weatherproof, Anti-Corrosion Frame" },
            { id: 4, title: "Installation", content: "Rooftop or Ground Mount Compatible" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Lucas Reed",
                date: "May 20, 2025",
                rating: 5,
                content: "Great investment! Easy setup and noticeable drop in our energy bill."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Sophia Turner",
                date: "May 23, 2025",
                rating: 4.5,
                content: "Durable panels with excellent efficiency. Highly recommend for homeowners."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Accent Chair",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Enhance any room with our stylish Accent Chair. Designed for comfort and charm, it's the perfect blend of elegance and everyday use. Enhance any room with our stylish Accent Chair. Designed for comfort and charm, it's the perfect blend of elegance and everyday use.",
        description: "Our Accent Chair features a cushioned seat, ergonomic backrest, and a sturdy wooden or metal frame. Ideal for bedrooms, living rooms, or reading nooks, its sleek profile complements a wide range of interior styles. Upholstered in soft, durable fabric, it offers long-lasting comfort and modern flair. Our Accent Chair features a cushioned seat, ergonomic backrest, and a sturdy wooden or metal frame. Ideal for bedrooms, living rooms, or reading nooks, its sleek profile complements a wide range of interior styles. Upholstered in soft, durable fabric, it offers long-lasting comfort and modern flair.",
        category: ["Furniture Pieces", "Home Accessories"],
        tags: ["chair", "seating", "accent"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Upholstered Fabric & Solid Wood/Metal Legs" },
            { id: 2, title: "Color Options", content: "Teal, Charcoal, Mustard" },
            { id: 3, title: "Weight Capacity", content: "Up to 300 lbs" },
            { id: 4, title: "Maintenance", content: "Spot clean with mild soap and damp cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Liam Foster",
                date: "May 27, 2025",
                rating: 5,
                content: "Very comfortable and looks great with our decor. Good build quality too!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Mia Collins",
                date: "May 30, 2025",
                rating: 4.5,
                content: "The color is beautiful and the chair is super comfy for reading."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Clock Decor",
        price: 50,
        disprice: 40,
        stock: 18,
        content: "Style meets function with our modern Clock Decor. A perfect timepiece that enhances your wall with elegance and practicality. Style meets function with our modern Clock Decor. A perfect timepiece that enhances your wall with elegance and practicality.",
        description: "Our Clock Decor combines reliable timekeeping with artistic design, making it a standout accent for any room. Crafted with quality materials like wood, metal, or glass, it adds both charm and purpose to your interior. Whether hung in the living room, kitchen, or office, this decorative clock brings a contemporary vibe while helping you stay on schedule. Our Clock Decor combines reliable timekeeping with artistic design, making it a standout accent for any room. Crafted with quality materials like wood, metal, or glass, it adds both charm and purpose to your interior. Whether hung in the living room, kitchen, or office, this decorative clock brings a contemporary vibe while helping you stay on schedule.",
        category: ["Furniture Pieces", "Home Accessories"],
        tags: ["clock", "decor", "wall"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Wood, Metal or Glass" },
            { id: 2, title: "Mechanism", content: "Silent Quartz Movement" },
            { id: 3, title: "Power Source", content: "1 AA Battery (not included)" },
            { id: 4, title: "Mounting", content: "Wall Mounted – Hardware Included" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Noah Daniels",
                date: "June 1, 2025",
                rating: 5,
                content: "Absolutely love how this clock adds a stylish touch to our hallway."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Grace Evans",
                date: "June 3, 2025",
                rating: 4.5,
                content: "Elegant design and very quiet. Matches our decor perfectly."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Dining Set",
        price: 50,
        disprice: 40,
        stock: 6,
        content: "Gather around in style with our elegant Dining Set. Perfect for family meals or casual dinners, it blends comfort with timeless charm. Gather around in style with our elegant Dining Set. Perfect for family meals or casual dinners, it blends comfort with timeless charm.",
        description: "Our Dining Set includes a sturdy table and matching chairs designed for both function and aesthetics. Built from high-quality wood or engineered materials, it features a spacious tabletop and supportive seating. Whether you're entertaining guests or enjoying everyday meals, this set brings warmth and sophistication to your dining space. Our Dining Set includes a sturdy table and matching chairs designed for both function and aesthetics. Built from high-quality wood or engineered materials, it features a spacious tabletop and supportive seating. Whether you're entertaining guests or enjoying everyday meals, this set brings warmth and sophistication to your dining space.",
        category: ["Furniture Pieces", "Home Accessories"],
        tags: ["dining", "furniture", "table"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Wood or MDF" },
            { id: 2, title: "Seating Capacity", content: "4 to 6 People" },
            { id: 3, title: "Finish Options", content: "Walnut, Oak, Espresso" },
            { id: 4, title: "Care Instructions", content: "Wipe clean with a damp cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Ethan Brooks",
                date: "June 5, 2025",
                rating: 5,
                content: "Great quality dining set. Very sturdy and looks great in our space."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Lily Bennett",
                date: "June 7, 2025",
                rating: 4.5,
                content: "Chairs are comfortable and the table is perfect for our family meals."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Wall Art",
        price: 50,
        disprice: 40,
        stock: 12,
        content: "Elevate your interiors with our captivating Wall Art. Perfect for any room, it adds personality and depth to your space. Elevate your interiors with our captivating Wall Art. Perfect for any room, it adds personality and depth to your space.",
        description: "Our Wall Art collection features carefully curated prints, paintings, and designs that complement a range of decor styles. Whether abstract, botanical, or geometric, each piece is printed on high-quality canvas or framed with durable materials. It's a simple yet impactful way to refresh your room's look and express your unique taste. Our Wall Art collection features carefully curated prints, paintings, and designs that complement a range of decor styles. Whether abstract, botanical, or geometric, each piece is printed on high-quality canvas or framed with durable materials. It's a simple yet impactful way to refresh your room's look and express your unique taste.",
        category: ["Wall Decor", "Home Accessories"],
        tags: ["art", "print", "decor"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Canvas, Wood Frame or Glass" },
            { id: 2, title: "Dimensions", content: "Varies by design (e.g., 16x20, 18x24)" },
            { id: 3, title: "Mounting", content: "Ready to Hang – Hooks Included" },
            { id: 4, title: "Care Instructions", content: "Dust lightly with dry cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Sophia Greene",
                date: "June 10, 2025",
                rating: 5,
                content: "Beautiful piece! It brought a whole new vibe to my living room."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Jackson Reed",
                date: "June 11, 2025",
                rating: 4.5,
                content: "Looks even better in person. Quality is great and easy to mount."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Flower Vase",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Add a graceful touch to any space with our elegant Flower Vase. Ideal for fresh blooms or decorative branches, it elevates your home decor. Add a graceful touch to any space with our elegant Flower Vase. Ideal for fresh blooms or decorative branches, it elevates your home decor.",
        description: "Our Flower Vase features a sleek and timeless design, made from high-quality ceramic, glass, or metal. Whether displayed on a dining table, shelf, or entryway console, it creates a charming focal point. Suitable for all seasons and arrangements, it's a versatile addition to your interior style. Our Flower Vase features a sleek and timeless design, made from high-quality ceramic, glass, or metal. Whether displayed on a dining table, shelf, or entryway console, it creates a charming focal point. Suitable for all seasons and arrangements, it's a versatile addition to your interior style.",
        category: ["Home Accessories", "Wall Decor"],
        tags: ["vase", "decor", "flower"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Ceramic, Glass or Metal" },
            { id: 2, title: "Dimensions", content: "Varies by design (e.g., 8\", 10\", 14\")" },
            { id: 3, title: "Finish Options", content: "Glossy, Matte, Textured" },
            { id: 4, title: "Care Instructions", content: "Wipe clean with a damp cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Mia Lawson",
                date: "June 12, 2025",
                rating: 5,
                content: "Stunning vase—adds just the right amount of elegance to my living room!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Lucas Ford",
                date: "June 13, 2025",
                rating: 4.5,
                content: "Solid build and looks great with fresh flowers or even empty as decor."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Desk Lamp",
        price: 50,
        disprice: 40,
        stock: 14,
        content: "Illuminate your workspace with our sleek Desk Lamp. Designed for function and form, it enhances focus while complementing modern interiors. Illuminate your workspace with our sleek Desk Lamp. Designed for function and form, it enhances focus while complementing modern interiors.",
        description: "Our Desk Lamp combines practical lighting with aesthetic appeal, making it ideal for study rooms, home offices, or bedside tables. It features adjustable arms or heads for focused lighting, energy-efficient LED options, and user-friendly touch or switch controls. A perfect blend of style and utility for any modern desk. Our Desk Lamp combines practical lighting with aesthetic appeal, making it ideal for study rooms, home offices, or bedside tables. It features adjustable arms or heads for focused lighting, energy-efficient LED options, and user-friendly touch or switch controls. A perfect blend of style and utility for any modern desk.",
        category: ["Lighting Fixtures", "Home Accessories"],
        tags: ["lamp", "lighting", "desk"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Metal, Plastic or Wood" },
            { id: 2, title: "Light Source", content: "LED (Warm or Cool White)" },
            { id: 3, title: "Features", content: "Adjustable Arm, Touch Control, Dimmable" },
            { id: 4, title: "Power", content: "USB or AC Plug" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Noah Carter",
                date: "June 13, 2025",
                rating: 5,
                content: "This desk lamp is perfect—bright, adjustable, and super stylish!"
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Chloe Adams",
                date: "June 13, 2025",
                rating: 4.5,
                content: "Compact design and good lighting range. Great for study sessions!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Window Shades",
        price: 50,
        disprice: 40,
        stock: 12,
        content: "Control natural light and add privacy with our stylish Window Shades. A functional and decorative addition to any room. Control natural light and add privacy with our stylish Window Shades. A functional and decorative addition to any room.",
        description: "Our Window Shades are crafted from high-quality materials designed to block or filter sunlight while complementing your interior décor. Easy to install and operate, they come in a variety of colors, textures, and light-filtering options. Ideal for bedrooms, living rooms, or offices, they strike the perfect balance between style and functionality. Our Window Shades are crafted from high-quality materials designed to block or filter sunlight while complementing your interior décor. Easy to install and operate, they come in a variety of colors, textures, and light-filtering options. Ideal for bedrooms, living rooms, or offices, they strike the perfect balance between style and functionality.",
        category: ["Window Treatments", "Home Accessories"],
        tags: ["shades", "window", "privacy"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Polyester, Linen Blend, Bamboo" },
            { id: 2, title: "Light Control", content: "Blackout, Light Filtering, Sheer" },
            { id: 3, title: "Installation", content: "Inside or Outside Mount" },
            { id: 4, title: "Care Instructions", content: "Vacuum gently or spot clean" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Ella Morgan",
                date: "June 13, 2025",
                rating: 4.5,
                content: "These shades are both stylish and practical. Love the light filtering effect!"
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Liam Brooks",
                date: "June 13, 2025",
                rating: 5,
                content: "Easy to install and looks great in our living room. Great value for money."
            }
        ]
    }

];

export default products;